import React from "react";
import Footer from "../components/footer/Footer";

const disclaimerParagraphs = [
  "Informasi yang tersedia pada website TokoMikro disediakan untuk tujuan informasi umum dan penggunaan layanan yang kami sediakan. Kami berupaya menjaga agar seluruh informasi yang ditampilkan akurat, lengkap, dan terkini, namun tidak memberikan jaminan atas keakuratan, kelengkapan, maupun kesesuaian informasi tersebut untuk tujuan tertentu.",
  "Penggunaan website dan layanan TokoMikro sepenuhnya menjadi tanggung jawab pengguna. Segala keputusan yang diambil berdasarkan informasi dari website ini merupakan tanggung jawab pengguna.",
  "TokoMikro tidak bertanggung jawab atas kerugian langsung maupun tidak langsung yang timbul akibat penggunaan website, termasuk namun tidak terbatas pada gangguan sistem, kehilangan data, keterlambatan layanan, atau kesalahan teknis yang berada di luar kendali kami.",
  "Website ini dapat berisi tautan menuju situs atau layanan pihak ketiga. TokoMikro tidak memiliki kendali atas isi maupun kebijakan dari situs tersebut dan tidak bertanggung jawab atas informasi atau layanan yang disediakan oleh pihak ketiga.",
  "Kami berhak mengubah, memperbarui, atau menghapus konten serta layanan pada website ini sewaktu-waktu tanpa pemberitahuan sebelumnya.",
  "Dengan menggunakan website TokoMikro, Anda dianggap telah memahami dan menyetujui isi Disclaimer ini.",
];

const DisclaimerPage = () => {
  return (
    <>
      <main>
        <section className="relative h-72 overflow-hidden bg-[#3f6fe5] [--hero-grid:115px] md:h-80 lg:h-96">
          <div
            className="pointer-events-none absolute inset-0 opacity-30"
            style={{
              backgroundImage:
                "linear-gradient(#aec0ed, #aec0ed), linear-gradient(#aec0ed, #aec0ed), linear-gradient(#aec0ed, #aec0ed), linear-gradient(#aec0ed, #aec0ed), linear-gradient(#aec0ed, #aec0ed)",
              backgroundRepeat: "no-repeat",
              backgroundSize:
                "var(--hero-grid) var(--hero-grid), var(--hero-grid) var(--hero-grid), var(--hero-grid) var(--hero-grid), var(--hero-grid) var(--hero-grid), var(--hero-grid) var(--hero-grid)",
              backgroundPosition:
                "calc(var(--hero-grid) * 3) 0, calc(var(--hero-grid) * 12) 0, calc(var(--hero-grid) * 13.6) var(--hero-grid), calc(var(--hero-grid) * 4) calc(var(--hero-grid) * 3), calc(var(--hero-grid) * 8) calc(var(--hero-grid) * 3)",
            }}
          ></div>
          <div
            className="absolute inset-0 opacity-70"
            style={{
              backgroundImage:
                "linear-gradient(rgba(255,255,255,0.28) 2px, transparent 2px), linear-gradient(90deg, rgba(255,255,255,0.28) 2px, transparent 2px)",
              backgroundSize: "var(--hero-grid) var(--hero-grid)",
            }}
          ></div>
          <div className="absolute inset-0 flex flex-col items-center justify-center px-4 text-center">
            <h1 className="text-3xl font-bold tracking-tight text-white drop-shadow-lg md:text-5xl lg:text-6xl">
              Disclaimer
            </h1>
            <p className="mt-4 max-w-3xl text-base leading-relaxed text-blue-100/90 drop-shadow md:text-lg">
              Terakhir diperbarui: 26 Juni 2026.
            </p>
          </div>
        </section>

        <section className="section-shell bg-white">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <article className="mx-auto max-w-4xl space-y-5">
              {disclaimerParagraphs.map((paragraph) => (
                <p key={paragraph} className="section-copy">
                  {paragraph}
                </p>
              ))}
            </article>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default DisclaimerPage;
